import React, { useState, useEffect } from "react";
import styles from "../../styles/components/getModal.module.scss";
import Icons from "../../public/assets/svg";
import DropDown from "../listWithoutcheck";
import axios from "axios";
import endpoints from "../../utility/endpoints";
import BasicForm from "../basicForm";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const ModalExample = (props) => {
  //console.log(props, "props of get modal");

  const modalRef = React.useRef(null);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        //  console.log(ref.current,"lllllll");
        // console.log(event.target,"eeeeeee");
        if (ref.current && !ref.current.contains(event.target)) {
          //props.setbotModal(false);
        }
      }

      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(modalRef);

  let leadPlatformData = props.globalData.lead_platform_main_component[0];
  let clusterData = props.globalData.cluster_main_component[0];
  let technologyData = props.data.field_get_bot_field[0];

  leadPlatformData.field_related_dropdown = "";
  clusterData.field_related_dropdown = "";

  let formData = [leadPlatformData, clusterData, technologyData];

  const [state, setState] = React.useState({ message: "" });

  //  const [dropDownState, setDropdownState] = React.useState({technology : false})
  const [userName, setUserName] = React.useState("");

  const inputChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  // dropdown open close
  //  const handleDropDown = (item) => {
  //    setDropdownState({
  //      ...dropDownState,
  //      [item]: !dropDownState[item],
  //    });
  //  };
  const getmodal = () => {
    props.setbotModal(false);
    document.body.style.overflow = "unset";
  };
  //  // dropdown value selected
  //  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
  //    console.log(value, dropdownParent, "parent")
  //    setDropdownState({ ...dropDownState, [dropdownParent]: false });
  //    setState({ ...state, [dropdownParent]: value });

  //  };

  React.useEffect(() => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    setUserName(auth.name);
  });

  const sendMessage = async () => {
    setGetFormValues(true);
  };

  const [getFormValues, setGetFormValues] = React.useState(false);
  const [invalidInputFlag, setInputInvalid] = React.useState(false);

  const recievedFormValues = async (formData) => {
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = await JSON.parse(localStorage.getItem("auth")).data;
      if (state["message"] == "") {
        setGetFormValues(false);
        setInputInvalid(true);
      } else {
        setInputInvalid(false);
        props.setLoading(true)
        axios({
          method: "post",
          url: `${endpoints.baseUrl}/getBot/createGetReq`,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
          data: {
            requestedBy: auth.email,
            botID: props.botID,
            ...formData,
            ...state,
          },
        }).then((res) => {
          if (res.data.code == 403) {
            props.sessionTimeOutCheck(true);
            props.setLoading(false)
            
          }
          if (res.data.code == 200) {
            //console.log("props ----", props);
            props.setBotModal(false);
            props.setSuccessModal(true);
            props.setLoading(false)
          }
        });
      }
    } else {
      props.sessionTimeOutCheck(true);
      props.setLoading(false)
    }
  };

  const emptyFormValues = () => {};

  return (
    <div className={styles.editModalWrapper}>
      <div className={styles.modalBox} ref={modalRef}>
        <div className={styles.modalHeader}>
          <p className={styles.content}>Get this bot</p>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.textBody}>
            <p className={styles.texthead}>
              Hello <strong> {userName}, </strong> thankyou for opting{" "}
              <strong>{props.botName}.</strong>{" "}
            </p>

            <p className={styles.textbody}>
              To complete the process for getting this bot, please fill the
              details below and we will get back to you as soon as possible.
            </p>
          </div>
          <div className={styles.basicForm}>
            <BasicForm
              formType="getBot"
              data={formData}
              sendFormValues={recievedFormValues}
              getFormValues={getFormValues}
              setGetFormValues={setGetFormValues}
              demandEditData={{
                leadPlatform: props.leadPlatform,
                technology: props.technology,
                cluster:props.cluster
              }}
            />
          </div>
          {/* <div className={styles.inputGroup}>
          
            <div className={styles.colFirst}>
              <div className={styles.row}>
                <div
                  className={ `${styles.inputGroup}`
                  }
                >
                  <label>
                    <span>
                      Technology
                    
                    </span>
                   
                  </label>
                  <p
                    className={`${styles.input} `}
                    onClick={() => {
                      handleDropDown("technology");
                    }}
                  >
                    <span className={styles.left}>
                      {state["technology"] == "" 
                        ? "-Select Technology-"
                        : state["technology"]}
                    </span>
                    <span className={styles.right}>
                      <Icons name="chevron" className={styles.chevron} />
                    </span>
                  </p>
                  {dropDownState["technology"] == true ? (
                    <div className={styles.dropdown}>
                      <DropDown
                        dropdownParent={"technology"}
                        
                        values={
                          ["RPA", "Chatbot"]
                        }
                        getDropdownValue={gotDropDownValue}
                        haveRelated={null}
                        param = "profile"
                      />
                    </div>
                  ) : null}
                  
                </div>
              </div>
            </div>
            
          </div> */}
          <div className={styles.inputGroup}>
            <div className={styles.labelStyle}>
              <label>
                <span>
                  Why do you want this bot?
                  <sup className={styles.sup}>*</sup>
                </span>
              </label>

              {invalidInputFlag ? (
                <span
                  className={styles.errorMessage}
                  style={{ color: "red", fontSize: "12px" }}
                >
                  Please fill the message
                </span>
              ) : null}
            </div>
            <textarea
              className={`${invalidInputFlag ? styles.errorBorder : null}`}
              placeholder="Type something"
              onChange={inputChange}
              name="message"
            ></textarea>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.combinedBtn}>
            <span className={styles.rowBtn} onClick={() => getmodal()}>
              Cancel
            </span>

            <span
              className={styles.exportListBtn}
              onClick={() => sendMessage()}
            >
              <Icons name="enquiryicon" className={styles.sendIcon} />
              Send Message
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalExample);
